import { useQuery } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

export function useMarketplaceStats() {
  return useQuery({
    queryKey: ['marketplace', 'stats'],
    queryFn: marketplaceService.getStats,
    staleTime: 5 * 60 * 1000,
  });
}
